export const editCompanyAction =(a)=>{
    return{
        type:"editCompany",
        value:a
    }
}